export default "__VITE_ASSET__B4UvyW2F__"